import { PartialTranslation } from '../translations';

export const ja: PartialTranslation = {
  newChat: '新しいチャット',
  search: '検索',
  user: 'ユーザー',
  settings: '設定',
  language: '言語',
  getHelp: 'ヘルプを取得',
  viewAllPlans: 'すべてのプランを表示',
  learnMore: '詳細を見る',
  logOut: 'ログアウト',
  chooseLanguage: '言語を選択',
  chooseYourPreferredLanguage: '使用する言語を選択してください',
  searchLanguages: '言語を検索...',
  autoDetect: '自動検出',
  noLanguagesFound: '言語が見つかりません',
  askAnything: '何でも聞いてください',
  lawhelperAi: 'Lawhelper.ai',
  personal: '個人',
  freePlan: '無料プラン',
  current: '現在',
  close: '閉じる',
  archive: 'アーカイブ',
  delete: '削除',
  confirmDelete: 'このチャットを削除してもよろしいですか？',
  confirmArchive: 'このチャットをアーカイブしてもよろしいですか？',
  deleteCannotUndo: 'この操作は元に戻せません。',
  archiveCanFind: 'アーカイブ後、アーカイブリストで見つけることができます。',
  // 归档标签页
  chats: 'チャット',
  archived: 'アーカイブ済み',
  restore: '復元',
  noArchivedChats: 'アーカイブされたチャットはありません',
  backToChats: 'チャットに戻る',
  // 资源面板
  resources: 'リソース',
  addResource: 'リソースを追加',
  deleteResource: 'リソースを削除',
  noMatchingResourcesFound: '一致するリソースが見つかりません',
  noResourcesAvailable: '利用可能なリソースがありません',
  hideResources: 'リソースを非表示',
  showResources: 'リソースを表示',

  // 聊天输入框
  typeMessage: 'メッセージを入力...',
  thinkingOptions: '思考オプション',
  deleteFile: 'ファイルを削除',
  clearSelection: '選択をクリア',

  // 思考模式选项
  deepInsight: '深い洞察 · 表面分析',
  deepInsightDesc: 'キーポイントの迅速な理解',
  deepExploration: '深い探索 · 包括的分析',
  deepExplorationDesc: '多次元的な詳細研究',
  deepDeconstruction: '深い解構 · 体系的論証',
  deepDeconstructionDesc: '段階的な進歩的分析',

  // 写作模式选项
  contractReview: '契約レビュー · リスク特定',
  contractReviewDesc: '条項分析とコンプライアンスチェック',
  textPolish: 'テキスト校正 · プロフェッショナル表現',
  textPolishDesc: '言語最適化と構造調整',
  legalDocuments: '法的文書 · 標準起草',
  legalDocumentsDesc: 'プロフェッショナルな法的文書作成',
  addAttachment: '添付ファイルを追加',
  sendMessage: 'メッセージを送信',

  // 认证和隐私翻译
  login: 'ログイン',
  register: '新規登録',
  welcomeBack: 'LawHelperへようこそ',
  loginSubtitle: 'AI法律リサーチアシスタント',
  continueWithGoogle: 'Googleで続ける',
  continueWithMicrosoft: 'Microsoftで続ける',
  continueWithWeChat: 'WeChatで続ける',
  orContinueWith: 'または続ける',
  emailTab: 'メール',
  phoneTab: '電話',
  emailPlaceholder: 'メールアドレスを入力',
  phonePlaceholder: '電話番号を入力',
  codePlaceholder: '6桁のコードを入力',
  sending: '送信中...',
  verifying: '確認中...',
  verify: '確認',
  sendMagicLink: 'マジックリンクを送信',
  getVerificationCode: 'コードを取得',
  resendCode: 'コードを再送信',
  resendIn: '再送信まで',
  magicLinkSent: 'マジックリンクをメールに送信しました',
  magicLinkHint: '安全なリンクをメールに送信します',
  otpSent: '確認コードを送信しました',
  agreeToTerms: '続けることで、以下に同意したことになります',
  privacyPolicy: 'プライバシーポリシー',
  termsOfService: '利用規約',
  and: 'と',
  privacyTitle: 'プライバシーは重要です',
  privacyIntro: '最高の体験を提供するために、クッキーと類似の技術を使用しています。',
  essentialCookies: '必須クッキー',
  essentialDesc: 'ウェブサイトの機能に必要',
  analyticsCookies: '分析クッキー',
  analyticsDesc: 'サービス改善に役立ちます',
  marketingCookies: 'マーケティングクッキー',
  marketingDesc: 'パーソナライズされたコンテンツに使用',
  acceptAll: 'すべて受け入れる',
  essentialOnly: '必須のみ',
  customize: 'カスタマイズ',
  savePreferences: '設定を保存',
  back: '戻る',
  readPrivacyPolicy: 'プライバシーポリシーを読む',
  cookiePolicy: 'クッキーポリシー',
  gdprCompliance: 'GDPR',
  piplCompliance: '個人情報保護法',

  // AI工具面板
  aiReview: 'AIレビュー',
  aiDraft: 'AI起草',
  smartAssistant: 'テンプレート',

  // 知识库搜索
  enableKnowledgeSearch: 'ナレッジ検索を有効化',
  knowledgeSearchDesc: 'AIがドキュメントを優先検索',
  clickToDisable: '無効にする',
  clickToEnable: '有効にする',

  // Landing page translations
  tagline: 'AI駆動の法務インテリジェンス',
  heroTitle1: 'Legal AI',
  heroTitle2: 'シンプルに。',
  jurisdictionsLabel: '対応法域',
  accuracyLabel: '精度',
  fasterLabel: '高速化',
  availableLabel: '24時間',
  platformCapabilities: '機能',
  testimonialQuote: '"LawHelperは法務業務を一変させました。"',
  testimonialAuthor: '法務専門家',
  testimonialPosition: '大手法律事務所パートナー',
  viewPricing: '料金を見る',
  footerPricing: '料金',
  footerPrivacy: 'プライバシー',
  footerTerms: '利用規約',
  footerContact: 'お問い合わせ',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  closeResourcesPanel: 'リソースパネルを閉じる',
  uploading: '%{fileName}をアップロード中...',
  processing: '%{fileName}を処理中...',
  uploadSuccess: '✓ %{fileName}のアップロード完了',
  uploadError: '✗ アップロード失敗: %{error}',
  quickAnswer: 'クイック回答',
  quickAnswerDesc: '簡単な質問に素早く回答',
  cancelRequest: 'キャンセル',
  library: 'ライブラリ',
  filterAll: 'すべて',
  filterChat: 'チャット',
  filterReview: 'レビュー',
  filterDraft: '起草',
  filterTemplate: 'テンプレート',
  filterForm: 'フォーム',
  thinking: '考え中...',
  thinkingProcess: '思考プロセス',
  analyzingLegalLogic: '法的ロジックを分析中...',
  lawhelperThinking: 'Lawhelperが考え中...',
  serviceError: 'サービスエラー',
  uploaded: 'アップロード済み',
  settingsGeneral: '一般',
  settingsNotifications: '通知',
  settingsAppearance: '外観',
  settingsProfile: 'プロフィール',
  settingsResponseNotifications: '応答通知',
  settingsResponseNotificationsDesc: 'AIの応答完了時に通知',
  settingsColorMode: 'カラーモード',
  settingsLight: 'ライト',
  settingsDark: 'ダーク',
  settingsSystem: 'システム',
  about: 'について',
  reviewTitle: '文書レビュー',
  exitReview: 'レビューを終了',
  uploadPrompt: 'PDFをアップロードしてレビュー開始',
  uploadButton: 'ファイルを選択',
  startChatConfig: '「この文書をレビュー」と入力して開始',
  reviewPlaceholder: 'メッセージまたは「この文書をレビュー」を入力...',
  analyzing: 'レビュー中...',
  reviewComplete: 'レビュー完了',
  issuesFound: '%{count}件の問題を発見',
  draftTitle: '法的文書の起草',
  draftPlaceholder: 'ここで編集またはAIに生成を依頼...',
  analyzingTemplate: 'テンプレートファイル%{name}を分析中...',
  templateAnalyzed: '✅ テンプレート%{name}の分析完了！修正方法をお知らせください。',
  templateAnalysisPrompt: 'テンプレートの主要条項を分析',
  parsingFailed: '⚠️ ファイルの解析に失敗しましたが、要件を記述できます。',
  generating: '生成中...',
  generatedSuccess: '✅ 文書が生成されました！エディタで確認・編集できます。',
  drafterWelcome: 'AI文書アシスタントへようこそ',
  drafterYouCan: '次のことができます：',
  drafterUploadTemplate: 'テンプレートをアップロードしてAI分析',
  drafterDescribeNeeds: '文書の要件を記述',
  drafterLetAiHelp: 'AIが契約書・協議書などの起草をサポート',
  drafterExamples: '例：',
  drafterExampleRental: '「賃貸契約書を作成してください」',
  drafterExampleLabor: '「テンプレートに基づいて労働契約を記入」',
  drafterInputPlaceholder: '文書の要件を記述してください...',
  drafterThinking: '考え中...',
  drafterHistoryTitle: '履歴',
  drafterNoHistory: '履歴なし',
  drafterNewChat: '新しいチャット',
  drafterHistory: '履歴',
  drafterRemoveAttachment: '添付を削除',
  drafterLineHeight: '行間',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Word (.docx)でエクスポート',
  drafterExportPdf: 'PDFでエクスポート',
  drafterSave: '文書を保存',
  drafterDownload: '文書をダウンロード',
  drafterUndo: '元に戻す',
  drafterRedo: 'やり直す',
  drafterBold: '太字',
  drafterItalic: '斜体',
  drafterStrike: '取り消し線',
  drafterUnderline: '下線',
  drafterHighlight: 'ハイライト',
  drafterLink: 'リンクを挿入',
  drafterAlignLeft: '左揃え',
  drafterAlignCenter: '中央揃え',
  drafterAlignRight: '右揃え',
  drafterAlignJustify: '両端揃え',
  drafterList: 'リスト',
  drafterBulletList: '箇条書き',
  drafterOrderedList: '番号付きリスト',
  drafterTaskList: 'タスクリスト',
  drafterOpenResource: 'リソースパネルを開く',
  drafterStopGeneration: '生成を停止',
  drafterAgentMode: 'Agentモード有効 | クリックで通常チャットに切替',
  drafterAgentModeOn: 'Agentモード有効 | クリックで通常チャットに切替',
  drafterAgentModeOff: '通常チャットモード | クリックでAgentモードに切替',
  drafterUploadAttachment: '添付をアップロード',
  drafterExit: '終了',
  drafterConfirm: '確認',
  drafterOpenLink: 'リンクを開く',
  drafterDeleteLink: 'リンクを削除',
  drafterQuote: '引用',
  workflowTitle: 'AIワークフロー',
  workflowRunning: '実行中...',
  workflowReady: '準備完了',
  workflowCompleted: '完了',
  workflowStartFailed: 'ワークフロー開始失敗',
  workflowExecutionFailed: 'ワークフロー実行失敗',
  workflowInterrupted: 'ワークフロー中断',
  workflowProcessing: '処理中...',
  workflowStepsCompleted: 'ステップ完了',
  workflowStepsTotal: 'ワークフロー完了（%{count}ステップ）',
  acceptChanges: '変更を承認',
  rejectChanges: '変更を拒否',
  changesAccepted: '変更を承認しました',
  changesRejected: '変更を拒否しました',
  stopWorkflow: '停止',
  restartWorkflow: '再開',
  startDrafting: '起草開始',
  interrupt: '停止',
  documentSubject: '文書の件名 *',
  documentType: '文書タイプ',
  jurisdiction: '管轄',
  specialRequirements: '特別な要件（任意）',
  clickStartDrafting: '「起草開始」をクリックしてワークフローを開始',
  docTypeContract: '契約書',
  docTypeAgreement: '合意書',
  docTypeNotice: '通知',
  docTypeLetter: '書簡',
  docTypePetition: '申立書',
  docTypeWill: '遺言書',
  docTypePowerOfAttorney: '委任状',
  countryChina: '中国',
  countryUSA: 'アメリカ',
  countryGermany: 'ドイツ',
  countryJapan: '日本',
  countryFrance: 'フランス',
  countryUK: 'イギリス',
  citationVerified: '検証済み',
  citationUnverified: '未検証',
  imageLoadFailed: '画像の読み込みに失敗',
  smartDocTitle: 'スマート文書アシスタント',
  smartDocChatTitle: 'AI文書アシスタント',
  smartDocDropPrompt: 'PDFファイルをここにドロップ',
  smartDocSelectFile: 'ファイルを選択',
  smartDocOr: 'または',
  smartDocWelcomeTitle: 'AI文書アシスタントへようこそ',
  smartDocWelcomeYouCan: '次のことができます：',
  smartDocUploadForAI: 'テンプレートをアップロードしてAI分析',
  smartDocDescribeDoc: '文書の要件を記述',
  smartDocLetAIDraft: 'AIが契約書・協議書などの起草をサポート',
  smartDocExamples: '例：',
  smartDocExampleRental: '「賃貸契約書を作成してください」',
  smartDocExampleLabor: '「テンプレートに基づいて労働契約を記入」',
  smartDocInputPlaceholder: '文書の要件を記述してください...',
  smartDocRemoveAttachment: '添付を削除',
  smartDocOpenResources: 'リソースパネルを開く',
  smartDocExit: '終了',
  reviewStartFailed: 'レビューワークフロー開始失敗',
  reviewFailed: 'レビュー失敗',
  reviewFoundIssues: 'レビュー完了、%{count}件の問題を発見。',
  cannotReadStream: '応答ストリームを読み取れません',
  parseEventFailed: 'ワークフローイベントの解析に失敗',
  errorPrefix: 'エラー',
  unknownError: '不明なエラー',
  file: 'ファイル',
  loading: '読み込み中...',
  localFolders: 'ローカルフォルダ',
  selectLocalFolder: 'ローカルフォルダを選択',
  reselectFolder: 'フォルダを変更',
  addToContext: 'チャットに追加',
  saveFile: '保存',
  renameFile: '名前変更',
  fileSaved: 'ファイルが保存されました',
  fileRenamed: 'ファイル名を%{name}に変更しました',
  browserNotSupported: 'お使いのブラウザはローカルフォルダアクセスに対応していません',
  noFolderSelected: 'ファイルを参照するにはローカルフォルダを選択してください',
  scanningFolder: 'フォルダをスキャン中...',
  selectFileToPreview: 'プレビューするファイルを選択',
  aiAnalyze: 'AI分析',
};
